import React from 'react';
import moment from 'moment';

import { useTask } from 'contexts/task';
import { Button, Stack, Tag, Text } from 'shell/components';
import { MAX_AI_FEEDBACK_LIMIT } from 'utils/constants';

const AIFeedbackSection = ({ task }) => {
    const { aiFeedback, setAIFeedbackOverlay, setAlertDialog, resetAlertDialog } = useTask();

    const aiFeedbackList = aiFeedback
        .filter(({ milestone_id }) => milestone_id === task.milestone_id)
        .sort((a, b) => a.created_on - b.created_on);

    let numAttemptsRemaining = MAX_AI_FEEDBACK_LIMIT - aiFeedbackList.length;
    if (numAttemptsRemaining < 0) numAttemptsRemaining = 0;

    return (
        <Stack spacing={5}>
            <Stack spacing={2}>
                <Stack alignItems={'center'} direction={'row'} spacing={2}>
                    <Text weight={'semibold'}>AI Instant Feedback</Text>
                    <Tag type={'general'} value={'new'} />
                </Stack>
                <Text>
                    AI utilizes both the assignment rubric and examples of your instructor’s feedback to deliver instant
                    personalized feedback tailored to this deliverable, helping you improve your work before submission.
                </Text>
            </Stack>
            {aiFeedbackList.length < MAX_AI_FEEDBACK_LIMIT ? (
                <Stack spacing={2}>
                    <Button
                        sx={{ width: 'fit-content' }}
                        variant={'secondary'}
                        onClick={() => {
                            setAlertDialog({
                                visible: true,
                                title: 'Feedback Attempt Counts For All Group Members',
                                content:
                                    'Feedback can only be generated three times per group. Please ensure that all members of your team are ready to receive feedback.',
                                actionButtonText: 'Continue',
                                variant: 'primary',
                                onConfirm: () => {
                                    setAIFeedbackOverlay({ open: true, aiFeedback: null });
                                    resetAlertDialog();
                                },
                                onCancel: resetAlertDialog,
                            });
                        }}
                    >
                        Get Feedback
                    </Button>
                </Stack>
            ) : null}
            <Stack spacing={2}>
                <Text>
                    Your Feedback ({numAttemptsRemaining} {numAttemptsRemaining === 1 ? 'attempt' : 'attempts'}{' '}
                    remaining)
                </Text>
                {aiFeedbackList.length ? (
                    aiFeedbackList.slice(0, MAX_AI_FEEDBACK_LIMIT).map((feedback) => (
                        <Stack key={feedback.id} direction={'row'} justifyContent={'space-between'}>
                            <Text color={'light'} variant={'p3'}>
                                Generated on {moment(feedback.created_on).format('MMM D [@] hh:mma')}
                            </Text>
                            <Button
                                variant={'borderless'}
                                onClick={() => setAIFeedbackOverlay({ open: true, aiFeedback: feedback })}
                            >
                                View Feedback
                            </Button>
                        </Stack>
                    ))
                ) : (
                    <Text color={'disabled'}>Feedback will be saved here for your reference.</Text>
                )}
            </Stack>
        </Stack>
    );
};

export default AIFeedbackSection;
